import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import MypageleftArea from '../../component/MypageleftArea';
import consts from '../../libs/consts';


import { getBase64, getMemberinfo } from "../../utils/utils";


import * as APIS from "../../utils/service";

export default function Contactus({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const selectFile = useRef(null);

    const [memberinfos, setmemberinfos] = useState(''); 
    const [lists, setlists] = useState([]); 
    const [writeflag, setwriteflag] = useState(false); 
    const [errmsg, seterrmsg] = useState(['', '']);   

    const [title, settitle] = useState('');   
    const [desc, setdesc] = useState('');   
    const [selnoticeidx, setselnoticeidx] = useState('');   
    const [uidx, setuidx] = useState('');   
    const [files, setfiles] = useState([]);   



    useEffect(() => {
        getMemberinfo(setmemberinfos);
        listopen();
    }, []);

    useEffect(()=>{
        if(location?.state?.type === "contactClick"){
            contactBtnClick();
            navigate("/Contactus")
        }
    },[location?.state?.type])


    useEffect(() => {
        seterrmsg(errmsg?.map(( xe, ie ) => ''));
    }, [title, desc]);

    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {}
        APIS.postData('/v1/cs/list', sender).then(({ data }) => {
            if(data){
                console.log(data);
                setlists(data);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });           
    }

    const newsUpdate = (uidx=null, removed=false) => {
        if(removed === false){
            if(title === ''){
                seterrmsg(errmsg?.map(( xe, ie ) => ie === 0 ? '제목을 입력해주세요.' : xe));
                return;
            }
            if(desc === ''){
                seterrmsg(errmsg?.map(( xe, ie ) => ie === 1 ? '내용을 입력해주세요.' : xe));
                return;
            }
        }

        let fileSetting = [];
        files?.map((x, i) => {
            fileSetting.push({base: x?.base64, ext: x?.ext});
        });

        let sender = {
            title: title,
            desc: desc,
            files: fileSetting
        }
        // console.log(sender);
        // return;
        dispatch(loadingflas({ loading: true }));

        APIS.postData('/v1/cs/insert', sender).then(({ data }) => {
            if(data){
                setwriteflag(false);
                listopen();
                setuidx('');
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });     
    }

    const contactBtnClick = ()=>{
        setwriteflag(true);
        setuidx('');
        settitle('');
        setdesc('');      
        setfiles([]);
    }

    return(
        <>
        <Layout header={false} actives={''}>
            <div className='mypagearea'>
                <div >
                    <MypageleftArea pages={5} />
                </div>
                <div 
                    className='padding32'
                >
                    {writeflag === false &&
                        <div className='pagetitle fontsize20 bolds'>문의하기</div>
                    }
                    
                    {writeflag === true ? 
                    <div >
                        <div className='backbuttonarea'>
                            <div>
                                <button onClick={() => { setwriteflag(false); }}>
                                    <img src={`./images/icons/back.svg`} /> 
                                </button>
                                <span className='fontsize16 bolds'>등록하기</span>
                            </div>
                            {/* <button onClick={() => { setwriteflag(false); }}>
                            문의하기
                            </button> */}
                        </div>
                        <div className='pagetitle fontsize20 bolds'>문의 등록하기</div>
                        <div className='margint20'>
                            <Input 
                                className={`inputs`}
                                setValue={settitle}
                                value={title}
                                name="mb_phone"
                                placeholder={'제목을 입력하세요.'}
                                error={errmsg[0]}
                            /> 
                        </div>
                        <div className='margint8'>
                            <textarea
                                onChange={(e) => {
                                    setdesc(e.target.value);
                                }}
                                placeholder={`문의 내용을 가능한 상세하게 입력해주세요.

* 오류 신고 시에는 반드시 작성해주세요.
1. 사용중인 웹 브라우저
2. 상세한 오류 내용`}
                                style={{
                                    width: '100%', height: 400, padding: 12,
                                    borderRadius: 4, border: '1px solid #DDD'
                                }}
                            >{desc}</textarea>
                        </div>
                        {errmsg[1] !== '' &&
                        <div>
                            <p className="input_error"><span></span>{errmsg[1]}</p>
                        </div>
                        }


                        <input type='file' ref={selectFile} style={{ display: 'none' }} onChange={(e) => {
                            let file = e.target.files[0];
                            getBase64(file).then(result => {
                                file["base64"] = result;
                                file["ext"] = file.name.split('.')[1];
                                //console.log("File Is", file);
                                setfiles([...files, file]);
                            })
                            .catch(err => { console.log(err); });
                        }} />

                        <div className='margint20'>
                            <span className='bolds'>첨부사진</span>
                            <span className='color666'>(선택) 최대 3장</span>
                        </div>
                        <div className="write_image_list">
                            {files?.length < 3 &&
                            <button 
                                type="button"
                                onClick={() => {
                                    selectFile.current.click();
                                }}
                            >
                                <p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M14.1053 13C14.1053 14.1579 13.1579 15.1053 12 15.1053C10.8421 15.1053 9.89474 14.1579 9.89474 13C9.89474 11.8421 10.8421 10.8947 12 10.8947C13.1579 10.8947 14.1053 11.8421 14.1053 13ZM22 10.8947V16.1579C22 18.7632 19.8684 20.8947 17.2632 20.8947H6.73684C4.13158 20.8947 2 18.7632 2 16.1579V10.8947C2 8.36842 3.97368 6.31579 6.44737 6.15789L7.76316 4.15789C8.26316 3.42105 9.07895 3 9.94737 3H14C14.8947 3 15.6842 3.44737 16.1842 4.15789L17.5 6.15789C20.0263 6.31579 22 8.36842 22 10.8947ZM16.2105 13C16.2105 10.6842 14.3158 8.78947 12 8.78947C9.68421 8.78947 7.78947 10.6842 7.78947 13C7.78947 15.3158 9.68421 17.2105 12 17.2105C14.3158 17.2105 16.2105 15.3158 16.2105 13ZM19.3684 9.84211C19.3684 9.26316 18.8947 8.78947 18.3158 8.78947C17.7368 8.78947 17.2632 9.26316 17.2632 9.84211C17.2632 10.4211 17.7368 10.8947 18.3158 10.8947C18.8947 10.8947 19.3684 10.4211 19.3684 9.84211Z" fill="#6164A5"/>
                                </svg>             
                                </p>
                                <p>{files?.length}<span className='color999'>/3</span></p>
                            </button>
                            }
                            {files?.map((x, i) => {
                                return (
                                    <div key={i} style={{ backgroundImage: `url(${x?.base64})`}}>
                                        <button 
                                            type="button"
                                            onClick={() => {
                                                seterrmsg(errmsg?.map(( xe, ie ) => ''));
                                                setfiles(files?.filter((x2, i2) => i2 !== i));
                                            }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                                <rect x="0.333984" width="16" height="16" rx="4" fill="#101010"/>
                                                <path fillRule="evenodd" clipRule="evenodd" d="M5.5683 5.23431C5.88072 4.9219 6.38725 4.9219 6.69967 5.23431L8.53398 7.06863L10.3683 5.23431C10.6807 4.9219 11.1873 4.9219 11.4997 5.23431C11.8121 5.54673 11.8121 6.05327 11.4997 6.36569L9.66536 8.2L11.4997 10.0343C11.8121 10.3467 11.8121 10.8533 11.4997 11.1657C11.1873 11.4781 10.6807 11.4781 10.3683 11.1657L8.53398 9.33137L6.69967 11.1657C6.38725 11.4781 5.88072 11.4781 5.5683 11.1657C5.25588 10.8533 5.25588 10.3467 5.5683 10.0343L7.40261 8.2L5.5683 6.36569C5.25588 6.05327 5.25588 5.54673 5.5683 5.23431Z" fill="white"/>
                                            </svg>                
                                        </button>
                                    </div>
                                );
                            })}

                        </div>                        
                        <div 
                            className='margint20'
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                            }}
                        >
                            <div style={{ width: '50%' }}>
                                <Button
                                    buttonTxt={'취소'}
                                    disabled={true} 
                                    onPress={() => { 
                                        setwriteflag(false);
                                    }}
                                />                                       
                            </div>
                            <div style={{ width: '50%'}}>
                                <Button
                                    buttonTxt={'등록'}
                                    styles={{ 
                                    }} 
                                    onPress={() => { 
                                        if(uidx !== ''){
                                            newsUpdate(uidx, false);
                                        } else {
                                            newsUpdate();
                                        }
                                    }}
                                />     
                            </div>                            
                        </div>                            
                    </div>                    
                    :
                    <>
                    <div 
                        className='margint20'
                        style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                        }}
                    >
                        <div className='fontsize16 bolds'>
                        문의하실 내용을 자유롭게 작성해주세요.<br />
                        담당자가 확인 후 빠르게 답변드리겠습니다.

                        </div>
                        <Button
                            buttonTxt={'문의하기'}
                            styles={{
                                width: 120, height: 40, fontSize: 14
                            }}
                            onPress={() => {
                                contactBtnClick();
                            }}                             
                        />
                    </div>                    
                    <div className='faqlistArea margint20'>
                        {lists?.length > 0 && lists?.map((x, i) => {
                            if(i > 20){
                                return;
                            }
                            return (
                                <div 
                                    className={`faqlistView `}
                                    key={i}
                                    style={{
                                        cursor: 'pointer', 
                                    }}

                                >
                                    <div style={{ alignItems: 'flex-start'}}>
                                        <div 
                                            style={{ 
                                                display: 'inline-block', width: 'calc(100% - 140px)', textAlign: 'left',
                                                fontWeight: 700, fontSize: 16
                                            }}
                                            onClick={() => {
                                                //navigate('/UseguideDetail', {state: { vidx: x?.idx }});
                                                setselnoticeidx(selnoticeidx*1 === x?.idx ? '' : x?.idx);
                                            }}
                                        >
                                            <div 
                                                className='textcut_online'
                                                style={{ 
                                                    display: 'inline-block', width: '100%', textAlign: 'left',
                                                    fontWeight: 700, fontSize: 16, 
                                                }}                                                
                                            >{x?.title}</div>
                                            <div className='fontsize12 color666'>{moment(x?.create_dt).format('YYYY.MM.DD HH:MM')}</div>
                                        </div>  
                                        <div>
                                            <span className={`${x?.status*1 === 99 ? 'color6164A5' : 'colorF00'}`}>{x?.status*1 === 99 ? '답변완료' : '처리중'}</span>
                                        </div>  
                                    </div>
                                    {selnoticeidx*1 === x?.idx &&
                                        <>
                                        <div className='color666' style={{ whiteSpace: 'pre-wrap' }}>
                                            {x?.desc}
                                        </div>
                                        {x?.files?.length > 0 &&
                                        <div
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 8, marginTop: 12}}
                                        >
                                            {x?.files?.map((x, i) => {
                                                return (
                                                    <img src={`${consts?.s3url}/${x?.file_path}`} onClick={() => { window.open(`${consts?.s3url}/${x?.file_path}`); }} style={{ width: 100, borderRadius: 4 }} />
                                                );
                                            })}
                                        </div>
                                        }
                                        {x?.answer &&
                                            <div 
                                                style={{ 
                                                    paddingLeft: 20, marginTop: 20, 
                                                    display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', gap: 4
                                                }}
                                            >
                                                <div>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M11.912 7.74408C12.2375 7.41864 12.7651 7.41864 13.0906 7.74408L17.2572 11.9107C17.5827 12.2362 17.5827 12.7638 17.2572 13.0893L13.0906 17.2559C12.7651 17.5814 12.2375 17.5814 11.912 17.2559C11.5866 16.9305 11.5866 16.4028 11.912 16.0774L15.4895 12.5L11.912 8.92259C11.5866 8.59715 11.5866 8.06951 11.912 7.74408Z" fill="#CCCCCC"/>
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M3.33333 2.5C3.79357 2.5 4.16667 2.8731 4.16667 3.33333V9.16667C4.16667 9.82971 4.43006 10.4656 4.8989 10.9344C5.36774 11.4033 6.00363 11.6667 6.66667 11.6667H16.6667C17.1269 11.6667 17.5 12.0398 17.5 12.5C17.5 12.9602 17.1269 13.3333 16.6667 13.3333H6.66667C5.5616 13.3333 4.50179 12.8943 3.72039 12.1129C2.93899 11.3315 2.5 10.2717 2.5 9.16667V3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5Z" fill="#CCCCCC"/>
                                                    </svg>                                                    
                                                </div>
                                                <div>
                                                    <div
                                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 4}}
                                                    >
                                                        <div 
                                                            style={{ 
                                                                width: 64, height: 25, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                borderRadius: 100, backgroundColor: '#333', color: '#fff', fontWeight: 700
                                                            }}
                                                        >답변</div>
                                                        <span className='fontsize12 color666'>{moment(x?.answer_dt).format('YYYY.MM.DD HH:MM')}</span>
                                                    </div>
                                                    <div style={{ marginTop: 12, whiteSpace: 'pre-wrap' }}>{x?.answer}</div>
                                                    {x?.answerfiles?.length > 0 &&
                                                    <div
                                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 8, marginTop: 12}}
                                                    >
                                                        {x?.answerfiles?.map((x, i) => {
                                                            return (
                                                                <img src={`${consts?.s3url}/${x?.file_path}`} onClick={() => { window.open(`${consts?.s3url}/${x?.file_path}`); }} style={{ width: 100, borderRadius: 4 }} />
                                                            );
                                                        })}
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        </>
                                    }
                                </div>
                            );
                        })}
                        {lists?.length === 0 &&
                            <div className='nolistArea'>
                                문의하신 내용이 없습니다.
                            </div>
                        }
                    </div>
                    </>
                    }


                </div>
            </div>
        </Layout>

        </>
    )
}

